<template>
  <v-card elevation="0" rounded="lg" :loading="loading">
    <v-card-text>
      <div class="d-flex align-center justify-space-between">
        <fee-scope-selecotor
          :organizationId="organizationId"
          :partyId="partyId"
          :scopeKeys="scopeKeys"
          :ticketGroupId="ticketGroupId"
          :ticketBlockId="ticketBlockId"
          @update:organizationId="organizationId = $event"
          @update:partyId="partyId = $event"
          @update:ticketGroupId="ticketGroupId = $event"
          @update:ticketBlockId="ticketBlockId = $event"
        ></fee-scope-selecotor>
        <v-btn icon @click="openInstructions()">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </div>
      <v-alert v-if="getFeesError" type="error">
        {{ getFeesError }}
      </v-alert>
      <v-row v-else-if="!firstLoad">
        <v-col cols="12" sm="7" md="8">
          <fees-config
            v-model="fees"
            :organizationId="organizationId"
            :partyId="partyId"
            :ticketGroupId="ticketGroupId"
            :ticketBlockId="ticketBlockId"
          ></fees-config>
        </v-col>
        <v-col cols="12" sm="5" md="4">
          <fee-preview
            :scope="scope"
            :organizationId="organizationId"
            :partyId="partyId"
            :ticketGroupId="ticketGroupId"
            :ticketBlockId="ticketBlockId"
            :fees="fees"
          ></fee-preview>
        </v-col>
      </v-row>
      <v-alert v-if="error" type="error">
        {{ error }}
      </v-alert>
      <div>
        <v-alert v-if="nonGlobalValidFees.length === 0" type="warning">
          Nenhuma taxa para salvar
        </v-alert>
        <v-alert v-if="nonGlobalValidFees.length > 0" type="info">
          Você está editando {{ nonGlobalValidFees.length }} taxas
        </v-alert>
        <v-btn
          @click="saveFees"
          :loading="saving"
          :disabled="loading || getFeesError || nonGlobalValidFees.length === 0"
          color="success"
        >
          Salvar
        </v-btn>
      </div>
    </v-card-text>
    <fee-instructions ref="feeInstructions"></fee-instructions>
  </v-card>
</template>

<script>
import FeePreview from "../../components/admin/feeManager/FeePreview.vue";
import FeesConfig from "../../components/admin/feeManager/FeesConfig.vue";
import FeeScopeSelecotor from "../../components/admin/feeManager/FeeScopeSelecotor.vue";
import FeeInstructions from "../../components/admin/feeManager/FeeInstructions.vue";
import FEES from "@/services/admin/fees";

export default {
  components: { FeePreview, FeesConfig, FeeScopeSelecotor, FeeInstructions },
  metaInfo: {
    title: "Taxas",
  },
  data() {
    return {
      firstLoad: true,
      loading: false,
      saving: false,
      error: null,
      getFeesError: null,

      organizationId: null,
      partyId: null,
      ticketGroupId: null,
      ticketBlockId: null,

      fees: [],
      scopeKeys: ["organizationId", "partyId", "ticketGroupId"],
    };
  },
  methods: {
    async getFees() {
      try {
        this.loading = true;
        this.getFeesError = null;
        const { fees } = await FEES.getFees({
          organizationId: this.organizationId,
          partyId: this.partyId,
          ticketGroupId: this.ticketGroupId,
          ticketBlockId: this.ticketBlockId,
        });
        fees.forEach((fee) => this.updateFee(fee));
        this.$root.$emit("update:fees", this.fees);
      } catch (error) {
        this.getFeesError = error.message || "Erro ao buscar as taxas";
      } finally {
        this.loading = false;
        this.firstLoad = false;
      }
    },
    updateFee(data) {
      const index = this.fees.findIndex(
        (fee) =>
          fee.paymentMethod === data.paymentMethod &&
          fee.paymentType === data.paymentType &&
          fee.organizationId === data.organizationId &&
          fee.partyId === data.partyId &&
          fee.ticketGroupId === data.ticketGroupId &&
          fee.ticketBlockId === data.ticketBlockId
      );
      if (index !== -1) this.fees[index] = data;
      else this.fees.push(data);
    },
    async saveFees() {
      try {
        this.saving = true;
        this.error = null;

        await FEES.saveFees(this.validFees);
      } catch (error) {
        this.error = error.message || "Erro ao salvar as taxas";
      } finally {
        this.saving = false;
      }
    },
    openInstructions() {
      this.$refs.feeInstructions.open();
    },
  },
  computed: {
    scope() {
      if (this.ticketGroupId) return "ticketGroup";
      if (this.partyId) return "party";
      if (this.organizationId) return "organization";
      return "global";
    },
    validFees() {
      const validFees = this.fees.filter(
        (fee) =>
          fee.innerFee.fixed !== null &&
          fee.innerFee.percent !== null &&
          fee.outerFee.fixed !== null &&
          fee.outerFee.percent !== null
      );
      return validFees;
    },
    nonGlobalValidFees() {
      const nonGlobalValidFees = this.validFees.filter(
        (fee) => fee.organizationId !== null
      );
      return nonGlobalValidFees;
    },
  },
  watch: {
    organizationId: function (newVal) {
      this.getFees();
    },
    partyId: function (newVal) {
      this.getFees();
    },
    ticketGroupId: function (newVal) {
      this.getFees();
    },
    ticketBlockId: function (newVal) {
      this.getFees();
    },
  },
  mounted() {
    this.getFees();
  },
};
</script>

<style></style>
